import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import sum from 'lodash/sum';
import has from 'lodash/has';
import { localizeDate } from '@/utils/date';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import formMixin from '../formMixin';
const defaultItemsPerPage = 15;
export default {
  name: 'NiotaClassicConsumersDataPoints',
  mixins: [formMixin],
  props: {
    dataPoints: {
      type: Array,
      required: true
      //default: () => [],
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      lclObject: {},
      clonedDataPoints: cloneDeep(this.dataPoints),
      selectedDpTypeObject: null,
      dataPoint: {
        ca: 0,
        ioa: 0,
        device: {}
      },
      dialogCol: 12,
      calculator: {
        type: null,
        ca: {
          bytes: 2,
          result: 0,
          input: [0, 0],
          lowHighBytes: false
        },
        ioa: {
          bytes: 3,
          result: 0,
          input: [0, 0, 0],
          lowHighBytes: false
        }
      },
      updateDp: false,
      dialogAdd: false,
      dialogWidth: '500px',
      showAddressCalculator: false,
      selectedApplication: null,
      isFetching: null,
      isFetchingDevices: null,
      devicesSelection: [],
      tableOptions: {
        sortBy: ['id'],
        sortDesc: [false],
        itemsPerPage: defaultItemsPerPage
      },
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      dptypes: [{
        type: 1,
        typeString: 'M_SP_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_SP_NA'),
        timeTag: false
      }, {
        type: 3,
        typeString: 'M_DP_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_DP_NA'),
        timeTag: false
      }, {
        type: 13,
        typeString: 'M_ME_NC',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_ME_NC'),
        timeTag: false
      }, {
        type: 15,
        typeString: 'M_IT_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_IT_NA'),
        timeTag: false
      }, {
        type: 30,
        typeString: 'M_SP_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_SP_TB'),
        timeTag: true
      }, {
        type: 31,
        typeString: 'M_DP_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_DP_TB'),
        timeTag: true
      }, {
        type: 36,
        typeString: 'M_ME_TF',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_ME_TF'),
        timeTag: true
      }, {
        type: 37,
        typeString: 'M_IT_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_IT_TB'),
        timeTag: true
      }],
      isDpFormValid: false,
      isValidDp: false,
      dpIndexBeforeUpdate: null
    };
  },
  computed: {
    clonedDataPointsIndexes() {
      return this.clonedDataPoints.map((currentValue, index) => {
        currentValue.arrayIndex = index;
        return currentValue;
      });
    },
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    tableHeaders() {
      return [{
        text: 'ID',
        value: 'id',
        align: 'center',
        sortable: true
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.title'),
        value: 'device.title',
        align: 'left',
        sortable: true
      }, {
        text: this.$i18n_t('NiotaClassic.Consumers.detail.measurement'),
        align: 'left',
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Consumers.detail.commonAddress'),
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Consumers.detail.infObjAddress'),
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Consumers.detail.type'),
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Consumers.detail.deadBand'),
        sortable: false
      }, ...(this.isIotHubManager ? [{
        align: 'end',
        sortable: false
      }] : [])];
    }
  },
  created() {
    this.isFetchingDevices = true;
    NiotaClassicApiService.devicesParserVariables().then(res => {
      this.devicesSelection = res.data.devices;
    }).catch(error => {
      // TODO: create toast with error message
      console.error('Could not fetch devices', error);
    }).finally(() => {
      this.isFetchingDevices = false;
    });
  },
  methods: {
    localizeDate,
    measurementVariable: item => item ? item.variable : '',
    rules(item) {
      return [v => !!v || this.$i18n_t('NiotaClassic.Consumers.itemIsRequired', {
        item
      })];
    },
    deleteItem(dataPointIndex) {
      this.clonedDataPoints.splice(dataPointIndex, 1);
    },
    editItem(dataPointIndex) {
      this.initDataPoint();
      this.updateDp = true;
      this.dpIndexBeforeUpdate = dataPointIndex;
      this.dataPoint = this.clonedDataPoints[dataPointIndex];
      this.selectedDpTypeObject = this.dataPointTypeObject(this.dataPoint.type);
      this.dialogAdd = true;
    },
    updateItem() {
      this.clonedDataPoints[this.dpIndexBeforeUpdate] = this.dataPoint;
      this.closeDpDialog();
    },
    initDataPoint() {
      this.dpIndexBeforeUpdate = null;
      this.updateDp = false;
      this.selectedDpTypeObject = null;
      this.dataPoint = {
        type: null,
        device: {}
      };
    },
    closeDpDialog() {
      this.dialogAdd = false;
      this.initDataPoint();
    },
    closeDpDialogWithoutSaving() {
      this.clonedDataPoints[this.dpIndexBeforeUpdate] = this.dataPoints[this.dpIndexBeforeUpdate];
      this.clonedDataPoints = cloneDeep(this.clonedDataPoints);
      this.closeDpDialog();
    },
    addItem() {
      this.updateDp = false;
      if (!this.clonedDataPoints) {
        this.clonedDataPoints = [];
      }
      this.selectedDpTypeObject = null;
      this.clonedDataPoints.push(this.dataPoint);
      this.closeDpDialog();
    },
    // type: ca: common address or ioa: Info Object address
    toggleAddressCalculator(type) {
      this.showAddressCalculator = !this.showAddressCalculator || this.calculator.type !== type;
      this.dialogWidth = this.showAddressCalculator ? 'fit-content' : '500px';
      this.dialogCol = this.showAddressCalculator ? 6 : 12;
      this.calculator.type = type;
    },
    byteLable(byteNumber) {
      return `${this.calculator.type.toUpperCase()} ${byteNumber} (Byte ${byteNumber})`;
    },
    calculateAddress() {
      let calculator = this.calculator[this.calculator.type];
      let input = calculator.input;
      if (!calculator.lowHighBytes) {
        input = [...input].reverse();
      }
      let result = input.map((byte, index) => byte * 256 ** index);
      calculator.result = sum(result);
    },
    setAsAddress(calculatorType) {
      this.dataPoint[this.calculator.type] = parseInt(this.calculator[this.calculator.type].result);
      this.toggleAddressCalculator(calculatorType);
    },
    findDataPointType() {
      const result = this.dataPoint.type ? this.dptypes.find(dataPoint => dataPoint.type === this.dataPoint.type).typeString : '';
      return result;
    },
    dataPointTypeObject(intType) {
      return this.dptypes.find(dataPoint => dataPoint.type === intType);
    },
    setDataPointType(dpObject) {
      this.dataPoint.type = dpObject ? dpObject.type : null;
    },
    updateOrAddItem(item) {
      return this.updateDp ? this.updateItem(item) : this.addItem(item);
    },
    convertToNumber(field) {
      this.dataPoint[field] = this.dataPoint[field] || this.dataPoint[field] === 0 ? parseInt(this.dataPoint[field]) : '';
    },
    handleSubmit() {
      if (this.isDpFormValid && this.dpValidation()) {
        this.updateOrAddItem();
      }
    },
    dpValidation() {
      this.isValidDp = has(this.dataPoint.device, 'id') && has(this.dataPoint, 'variable.variable') && this.dptypes.find(dp => dp.type === this.dataPoint.type) !== -1;
      return this.isValidDp;
    },
    dpFormValidation() {
      this.isDpFormValid = (this.$refs && this.$refs.form ? this.$refs.form.validate() : false) && this.dpValidation();
    },
    validateAllDataPoints() {
      this.clonedDataPoints.forEach(dataPoint => {
        dataPoint.invalid = false;
        dataPoint.duplicate = false;
      });
      let intAddValidation = this.dpIntAddressValidation(this.clonedDataPoints);
      let dataPointsValidation = this.dpAddressValidation(this.clonedDataPoints, 'ca', 'ioa');
      let devicesValidation = this.devicesValidation();
      if (dataPointsValidation.valid && devicesValidation && intAddValidation) {
        this.clonedDataPoints.forEach(dataPoint => {
          delete dataPoint.duplicate;
          delete dataPoint.invalid;
        });
      } else {
        if (!devicesValidation) {
          this.$snack(this.$i18n_t('NiotaClassic.Consumers.iecValidationErrors.validDevice'), 'error');
        } else {
          dataPointsValidation.duplicateAddress.forEach(dataPoint => this.clonedDataPoints[dataPoint.index].duplicate = true);
        }
      }
      this.clonedDataPoints = cloneDeep(this.clonedDataPoints);
      let validation = this.clonedDataPoints.filter(dp => dp.invalid || dp.duplicate).length === 0;
      if (!validation) {
        this.$snack(this.$i18n_t('NiotaClassic.Consumers.iecValidationErrors.dpValidationError'), 'error');
      }
      return {
        validation,
        dataPoints: this.clonedDataPoints
      };
    },
    isInt(number) {
      return number === parseInt(number, 10);
    },
    dpIntAddressValidation(dataPoints) {
      let valid = true;
      dataPoints.forEach(dataPoint => {
        if (!dataPoint.ca || !dataPoint.ioa || !this.isInt(dataPoint.ca) || !this.isInt(dataPoint.ioa)) {
          dataPoint.invalid = true;
          valid = false;
        }
      });
      return valid;
    },
    devicesValidation() {
      let invalidDevices = this.clonedDataPoints.find(dataPoint => !dataPoint.device || !dataPoint.variable);
      return invalidDevices ? false : true;
    },
    dpAddressValidation(dataPoints, property1, property2) {
      let duplicateAddress = [];
      dataPoints.forEach((item, index) => {
        let duplicateItems = dataPoints.filter(xItem => {
          return xItem[property1] === item[property1] && xItem[property2] === item[property2];
        });
        if (duplicateItems.length > 1) {
          duplicateAddress.push({
            index,
            item
          });
        }
      });
      return {
        duplicateAddress,
        valid: duplicateAddress.length ? false : true
      };
    }
  }
};